import { Faq } from "./faq";
export var Help = function Help() {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Faq, null));
};